module.exports = __webpack_public_path__ + "img/flag_usa.1f506396.svg";